module.exports = __webpack_public_path__ + "static/img/casjobs.ba408d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/casjobs.png
// module id = zCUr
// module chunks = 1